<template>
  <b-form-select :id="safeId()" v-model="localValue" :options="options"
                 text-field="label" value-field="albumId">
  </b-form-select>
</template>

<script>
  export default {
    name: 'album-select',
    props: ['value'],
    data () {
      return {
        localValue: this.value
      }
    },
    computed: {
      options () {
        const options = this.$store.getters.albums().map(a => {
          return {
            albumId: a.albumId,
            label: a.name || a.albumId
          }
        })
        options.push({albumId: null, label: ''})
        options.sort((a, b) => {
          if (a.label < b.label) return -1
          if (a.label > b.label) return 1
          return 0
        })
        return options
      }
    },
    watch: {
      localValue: function (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/album-select.vue